import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot } from "vue"

import {
  ref, toRefs, Ref, computed, watchEffect,
} from 'vue';
import { Account, AccountPresenter } from '@/models';
import { AccountAddress, toPublicKeyAsString, zipMap } from '@/utils';
import { fetchMultipleAccounts, FetchMultipleAccountsPipe } from '@/api';

interface LoadedAccount {
  loading: boolean,
  account: Account | null,
  presenter: AccountPresenter | null,
  address: AccountAddress | null,
  addressAsString: string,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    addresses: null,
    pipe: null
  },
  setup(__props: any) {

const props = __props as {
  addresses: AccountAddress[],
  pipe?: FetchMultipleAccountsPipe,
}



const { addresses, pipe } = toRefs(props);
const loadedAccounts: Ref<LoadedAccount[]> = ref([]);

const reset = (loading = true) => {
  loadedAccounts.value = addresses.value.map((address) => ({
    loading,
    account: null,
    presenter: null,
    address,
    addressAsString: toPublicKeyAsString(address),
  }));
};

const fetch = async () => {
  try {
    reset();
    const accountPromises = await fetchMultipleAccounts(addresses.value, pipe?.value);
    const loadedPromises = zipMap(loadedAccounts.value, accountPromises, async (loadedAccount, accountPromise) => {
      const account = await accountPromise;
      loadedAccount.loading = false;
      loadedAccount.account = account;
      loadedAccount.presenter = account ? new AccountPresenter(account) : null;
    });

    await Promise.allSettled(loadedPromises);
  } finally {
    loadedAccounts.value.forEach((loadedAccount) => {
      loadedAccount.loading = false;
    });
  }
};

const scope = computed(() => ({
  accounts: loadedAccounts.value,
  fetch,
}));

watchEffect(fetch);

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(scope))))
}
}

})